import React from "react"
import { compose, withHooks } from "enhancers"
import { Button } from "components"
import PropTypes from "prop-types"

const BrowseButton = ({ getRootProps, getInputProps, children, ...buttonProps }) => (
  <Button {...buttonProps} {...getRootProps()}>
    <input autoComplete="off" value={undefined} {...getInputProps()} />
    {children}
  </Button>
)

const enhancer = compose(
  withHooks((props, hooks) => {
    const { onBrowse, accept, multiple = false, ...rest } = props
    const { useState, useCallback, useDropzone } = hooks
    const [loading, setLoading] = useState(false)

    const onDrop = useCallback(
      async (files) => {
        if (onBrowse) {
          setLoading(true)
          try {
            await onBrowse(files[0])
          } catch (e) {}
          setLoading(false)
        }
        setLoading(false)
      },
      [onBrowse],
    )

    const { getRootProps, getInputProps } = useDropzone({
      onDrop,
      accept,
      multiple,
    })

    return {
      getRootProps,
      getInputProps,
      ...rest,
      loading,
    }
  }),
)

BrowseButton.propTypes = {
  getRoot: PropTypes.any.isRequired,
  getInput: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
  getRootProps: PropTypes.any.isRequired,
  getInputProps: PropTypes.any.isRequired,
}

export default enhancer(BrowseButton)
